import { createAsyncThunk } from '@reduxjs/toolkit';
import { CHANNEL_TYPE } from '../../../helper/channelTypeHelper';
import { getErrorMsg } from '../../../helper/errorMessages';
import { openErrorDialog } from '../../errorDialogSlice/errorDialogSlice';
import changeSelectedChannelId from './changeSelectedChannelId';
import fetchCurrentUserChannels from './fetchCurrentUserChannels';

const createSalesSpace = createAsyncThunk(
  'channels/createSalesSpace',
  async ({ assignmentId, userIds }, { dispatch, rejectWithValue, extra: { gccApiClient } }) => {
    try {
      const channelType = CHANNEL_TYPE.SALES_SPACE;
      const response = await gccApiClient.createChannelFromAssignment(assignmentId, userIds, channelType);

      // Handles response errors
      if (response.error_code) {
        dispatch(
          openErrorDialog({
            dialogErrorButtonText: 'Zurück',
            dialogErrorMsg: getErrorMsg(response.error_code) || getErrorMsg('create_channel.default'),
            dialogErrorTitle: 'Fehler',
          }),
        );
        return rejectWithValue({ error: response.error_code });
      }

      await dispatch(fetchCurrentUserChannels({ specificChannelId: response?.id }));
      dispatch(changeSelectedChannelId({ selectedChannelId: response?.id }));

      return { success: response };
    } catch (_error) {
      // Handles offline errors
      return dispatch(
        openErrorDialog({
          dialogErrorButtonText: 'Zurück',
          dialogErrorMsg: 'Sie haben keine Verbindung zum Internet. Bitte versuchen Sie es erneut.',
          dialogErrorTitle: 'Fehler',
        }),
      );
    }
  },
);

export default createSalesSpace;
